(() => {
  const init = () => document.querySelectorAll('[data-cch-header]').forEach(root => {
    if (root.dataset.cchBound) return;
    root.dataset.cchBound = 'true';
    const panels = {shop:root.querySelector('#CchShop'),about:root.querySelector('#CchAbout'),trade:root.querySelector('#CchTrade'),mobile:root.querySelector('#CchMobile')};
    const triggers = [...root.querySelectorAll('[data-cch-toggle]')];
    let active = null;
    let returnFocus = null;
    const measure = () => {
      const bottom = root.getBoundingClientRect().bottom;
      root.style.setProperty('--cch-bottom', `${bottom}px`);
      return bottom;
    };
    const close = (restore = false) => {
      Object.values(panels).forEach(p => { if(p) p.hidden = true; });
      triggers.forEach(t => t.setAttribute('aria-expanded','false'));
      root.classList.remove('cch-shop-open','cch-about-open','cch-trade-open','cch-mobile-open');
      document.body.classList.remove('cch-menu-open');
      active = null;
      if (restore && returnFocus) returnFocus.focus();
    };
    const toggle = (name, trigger) => {
      if (active === name) { close(); return; }
      close();
      active = name;
      returnFocus = trigger;
      panels[name].hidden = false;
      trigger.setAttribute('aria-expanded','true');
      root.classList.add(`cch-${name}-open`);
      measure();
      if(name === 'mobile') {
        document.body.classList.add('cch-menu-open');
        panels.mobile.querySelector('[data-cch-close]').focus();
      }
    };
    triggers.forEach(t => t.addEventListener('click',() => toggle(t.dataset.cchToggle,t)));
    root.querySelectorAll('[data-cch-close]').forEach(t => t.addEventListener('click',() => close(true)));
    document.addEventListener('click',e => { if(active && !root.contains(e.target)) close(); });
    document.addEventListener('keydown',e => {
      if(e.key === 'Escape' && active) { e.preventDefault(); close(true); }
      if(e.key === 'Tab' && active === 'mobile') {
        const focusables = [...panels.mobile.querySelectorAll('a[href],button,summary')].filter(el => el.getClientRects().length);
        const first = focusables[0], last = focusables[focusables.length-1];
        if(e.shiftKey && document.activeElement === first) {e.preventDefault();last.focus();}
        else if(!e.shiftKey && document.activeElement === last) {e.preventDefault();first.focus();}
      }
    });
    root.addEventListener('focusout',e => { if(active && e.relatedTarget && !root.contains(e.relatedTarget)) close(); });
    root.querySelectorAll('.show-search-link,.cart-link').forEach(a => a.addEventListener('click',() => close()));
    const scroll = () => {
      const bottom = measure();
      const hero = root.classList.contains('cch-header--home') && document.getElementById('cch-hero');
      root.classList.toggle('cch-scrolled',hero ? hero.getBoundingClientRect().bottom <= bottom : window.scrollY > 50);
    };
    window.addEventListener('scroll',scroll,{passive:true});
    window.addEventListener('resize',() => {close();scroll();},{passive:true});
    scroll();
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();

